<template>
	<div class="wx-pay" v-show="payData.realAmount">
		<div class="order-no">{{ payData.orderGameNo }}</div>
		<div class="amt">
			<span v-show="payData.realAmount">￥</span>
			{{ payData.realAmount | money }}
		</div>
		<div class="btn" @click="wxPay">立即支付</div>
	</div>
</template>

<script>
import { PROXY_URL } from '@/config/env';
import { createBaseOrderOfJssdk } from '../../service/getData';

export default {
	name: 'wxPay',
	data() {
		return {
			payData: {}
		};
	},
	filters: {
		money(v) {
			if (!v || isNaN(v)) {
				return '';
			} else {
				return v.toFixed(2);
			}
		}
	},
	async mounted() {
		if (!this.$route.query.openId) {
			let href = window.location.href;
			//先切换路由再跳转授权，解决微信7.0.9授权回跳后页面空白问题。
			this.$router.replace({
				path: '/blank'
			});
			window.location.replace(`${PROXY_URL.config}/xubei-common-cloud/anon/wechat/gzh/oauth2/authorize?returnUrl=${encodeURIComponent(href)}`);
			return;
		}
		document.title = '确认交易';

		this.hideOptionMenu();

		let { balanceNo, tradeType, openId } = this.$route.query;

		if (!balanceNo || !tradeType || !openId) {
			alert('支付参数错误，请重试');
			this.closePage();
			return;
		}

		try {
			this.payData = await this.createBaseOrderOfJssdk();
		} catch (e) {
			alert(e.message || '查询支付信息失败，请重试');
			this.closePage();
		}
	},
	methods: {
		createBaseOrderOfJssdk() {
			let { balanceNo, tradeType, openId } = this.$route.query;
			return createBaseOrderOfJssdk({
				balanceNo,
				tradeType,
				openId
			});
		},

		wxPay() {
			let onBridgeReady = () => {
				if (!this.payData.jssdkInfo) {
					return;
				}
				WeixinJSBridge.invoke('getBrandWCPayRequest', this.payData.jssdkInfo, (res) => {
					if (res.err_msg == 'get_brand_wcpay_request:ok') {
						if (this.payData.adUrl) {
							location.href = this.payData.adUrl;
						} else {
							this.closePage();
						}
					} else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
					} else if (res.err_msg == 'get_brand_wcpay_request:fail') {
						this.closePage();
					}
				});
			};

			if (typeof WeixinJSBridge == 'undefined') {
				if (document.addEventListener) {
					document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
				} else if (document.attachEvent) {
					document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
					document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
				}
			} else {
				onBridgeReady();
			}
		},

		hideOptionMenu() {
			function onBridgeReady() {
				WeixinJSBridge.call('hideOptionMenu');
			}
			if (typeof WeixinJSBridge == 'undefined') {
				if (document.addEventListener) {
					document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
				} else if (document.attachEvent) {
					document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
					document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
				}
			} else {
				onBridgeReady();
			}
		},

		closePage() {
			function close() {
				WeixinJSBridge.call('closeWindow');
			}

			if (typeof WeixinJSBridge == 'undefined') {
				if (document.addEventListener) {
					document.addEventListener('WeixinJSBridgeReady', close, false);
				} else if (document.attachEvent) {
					document.attachEvent('WeixinJSBridgeReady', close);
					document.attachEvent('onWeixinJSBridgeReady', close);
				}
			} else {
				close();
			}
		}
	}
};
</script>

<style scoped lang="scss">
.wx-pay {
	position: absolute;
	width: 100%;
	height: 100%;
	background: #f9f9f9;
	text-align: center;
	color: #333;
	.order-no {
		padding-top: 0.6rem;
		font-size: 0.28rem;
		height: 1rem;
	}

	.amt {
		font-size: 0.7rem;
		font-weight: bold;
		margin-bottom: 0.6rem;
		height: 1rem;
		span {
			font-size: 0.64rem;
		}
	}

	.btn {
		background: #07c160;
		color: #fff;
		height: 1.02rem;
		line-height: 1.02rem;
		border-radius: 0.1rem;
		font-size: 0.36rem;
		text-align: center;
		margin: 0 0.5rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/pay/wxPay.vue